module.exports = __webpack_public_path__ + "static/media/konfigurator.bb9e256d.jpg";